import React from "react"

const Header = () => (
    <h1 className="header">Ask Rocky the WeatherDog for a report:</h1>
)

export default Header